"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseMeal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const with_collapse_1 = require("../../molecules/with-collapse");
const MealHeader_1 = __importDefault(require("./MealHeader"));
const MealDetails_1 = __importDefault(require("./MealDetails"));
const styled_components_1 = __importDefault(require("styled-components"));
const CollapseMeal = ({ unit, meal, translations }) => {
    return ((0, jsx_runtime_1.jsx)(Content, { children: (0, jsx_runtime_1.jsx)(with_collapse_1.WithCollapse, { header: (0, jsx_runtime_1.jsx)(MealHeader_1.default, { unit: unit, name: meal.name, nutritionFacts: meal.nutritionFacts, translations: translations, shouldRenderMealPlanIcon: Boolean(meal.isMealPlan) }, void 0), body: (0, jsx_runtime_1.jsx)(MealDetails_1.default, { translations: translations, unit: unit, meal: meal }, void 0) }, void 0) }, void 0));
};
exports.CollapseMeal = CollapseMeal;
const Content = styled_components_1.default.div `
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div > div:first-of-type {
      padding: ${({ theme }) => theme.spacings.m};
    }
  }
`;
//# sourceMappingURL=CollapseMeal.js.map